"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomString = void 0;
const WebApi_1 = __importDefault(require("./WebApi"));
function randomString(length = 16) {
    var _a;
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let output = '';
    if (length < 0) {
        return output;
    }
    const randomValues = new Uint32Array(length);
    (_a = WebApi_1.default.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues(randomValues);
    randomValues.forEach((value) => {
        output += characters.charAt(value % charactersLength);
    });
    return output;
}
exports.randomString = randomString;
//# sourceMappingURL=utils.js.map